var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinToCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 15V8.8V6.6C17 6.04772 16.5523 5.6 16 5.6H9.05092C8.72241 5.6 8.41486 5.43865 8.22815 5.16837L7.71922 4.43164C7.53251 4.16135 7.22495 4 6.89645 4H4C3.44772 4 3 4.44772 3 5V8.8V15C3 15.5523 3.44772 16 4 16H16C16.5523 16 17 15.5523 17 15Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4664 10.5222L17.0844 7.90418L17.1098 7.92956L17.5341 8.35383L17.9584 7.92956L18.4533 7.43457L18.8776 7.01031L18.4533 6.58605L14.8664 2.99912L14.4422 2.57486L14.0179 2.99912L13.5229 3.49411L13.0986 3.91838L13.5229 4.34264L13.5483 4.36802L10.9301 6.98617L9.74745 6.996L9.50184 6.99805L9.32817 7.17172L8.83372 7.66617L8.40946 8.09043L8.83372 8.5147L10.2086 9.88956L8.38353 11.7146L8.2078 11.8904L8.2078 12.1389L8.2078 12.6333L8.2078 13.2327L8.80714 13.2333L9.30213 13.2339L9.55104 13.2341L9.72705 13.0581L11.5521 11.2331L12.9383 12.6193L13.3626 13.0435L13.7868 12.6193L14.2813 12.1248L14.4551 11.9511L14.457 11.7053L14.4664 10.5222Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinToCategory);
export default __webpack_public_path__ + "static/media/pin_to_category.578952b3abc8d8ccad1135fc9fae0c8f.svg";
export { ForwardRef as ReactComponent };